import styled from 'styled-components';
import { Switch as AlchemySwitch } from '@m/alchemy-ui/Switch';
import { Pill } from '@m/alchemy-ui/Pill';
import { color, units, typeStyle } from '@m/alchemy-ui/theme';
import AlchemyDisplayBox from 'common/alchemyComponents/AlchemyDisplayBox';
import { RadioGroup } from '@m/alchemy-ui/RadioGroup';

export const Switch = styled(AlchemySwitch)`
  input {
    background: none;
    border: none;
    &:focus {
      border: none;
    }
  }
`;

export const ErrorPill = styled.div`
  display: flex;
  gap: ${units(1)};
  align-items: center;
  white-space: nowrap;
  border-radius: ${units(6)};
  padding: ${units(0.5)} ${units(1)};
  color: ${color('base', { palette: 'interactiveDestructive' })};
  background: ${color('hint', { palette: 'interactiveDestructive' })};
  ${typeStyle('subHeaderS')}
`;

export const RoundedImage = styled.img`
  aspect-ratio: 1;
  border-radius: 100%;
  height: ${units(3)};
  margin-right: ${units(1)};
  width: ${units(3)};
`;

export const EmployeePill = styled(Pill)`
  ${typeStyle('actionM')}
  width: fit-content;
  display: flex;
  align-items: center;
  background-color: unset;
  border: 1px solid ${color('line')};
  padding: 2px;
  padding-right: ${units(2)};
  margin-right: ${units(0.5)};
  margin-bottom: ${units(1)};
  white-space: nowrap;
  &.error {
    border-color: ${color('highlight', { palette: 'expressiveNegative' })};
    background: ${color('hint', { palette: 'expressiveNegative' })};
  }
`;

export const Section = styled(AlchemyDisplayBox)`
  display: flex;
  flex-direction: column;
  gap: ${units(4)};
  padding: ${units(4)} ${units(3)};
`;

export const SubSection = styled.div`
  display: flex;
  gap: ${units(3)};
  & ~ div {
    border-top: 1px solid ${color('line', { palette: 'structural' })};
    padding-top: ${units(4)};
  }

  h3 {
    padding: 6px 0;
    ${typeStyle('headerM')}
  }
  h4 {
    ${typeStyle('subHeaderM')}
    color: ${color('typeSubHeader')};
  }
  h3 ~ div,
  h4 ~ div {
    margin-top: ${units(3)};
  }
  .subsection-icon {
    margin: 6px;
  }
`;

export const StyledRadioGroup = styled(RadioGroup)`
  border-radius: ${units(6)};
  background: ${color('container', { colorScheme: 'alchemyPanel' })};
  width: fit-content;
  gap: 0;
  & > div {
    display: inline;
    padding: 8px 24px 8px 12px;
  }
  label span {
    font-weight: bold;
    &:first-of-type {
      background: ${color('container')};
    }
  }
`;
